import React from 'react';
import PropTypes from 'prop-types';

import PlotWrapperTooltip from '../../common/PlotWrapper/PlotWrapperTooltip';
import useStyles from './styles';

const TopWidget = ({ title, value, icon, tooltipText }) => {
  const classes = useStyles();

  return (
    <div className={classes.topWidget}>
      <div className={classes.topWidgetTitle}>
        {title}
        {tooltipText && <PlotWrapperTooltip tooltipText={tooltipText} />}
      </div>
      <div className={classes.topWidgetValue}>{value}</div>
      <div className={classes.topWidgetIcon}>
        <img src={icon} alt="icon" />
      </div>
    </div>
  );
};


TopWidget.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
  icon: PropTypes.string.isRequired,
};

export default TopWidget;
